import { AuthUser, signIn, signOut } from "aws-amplify/auth";
import { useEffect, useRef, useState } from "react";
import { Nav, Navbar, Container, NavDropdown, Form, Button, InputGroup, Row, Col, Badge} from 'react-bootstrap';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import i18n from "../../../contexts/I18n";
import { useTranslation} from "react-i18next";
import Cookies from 'js-cookie';
import UserImage from "../../../components/UserImage";
import { FaRegBell } from "react-icons/fa6";
import { useNotification } from "../../../contexts/NotificationProvider";
import useNotificationStorageService from "../NotificationStorageService";
import { MessagePayload, onMessage } from "firebase/messaging";
import { messaging } from "../../../firebase-messaging";
import { PUBLIC_ID } from "../../../config";

// Extend Window interface to declare 
// onTokenReceived, onNativeNotificationReceived & onNativeNotificationLinkReceived
// with webkit & chrome for platform detection
declare global {
  interface Window {
    onTokenReceived?: (token: string) => void;
    onNativeNotificationReceived?: (data: any) => void;
    onNativeNotificationLinkReceived?: (data: any) => void;
    webkit?: {
      messageHandlers?: any;
    };
    // chrome?: {
    //   webview?: {
    //     hostObjects?: { 
    //       schedulumHost: any
    //     }
    //   }
    // }
  }
}

// const isWindowApp = window.chrome?.webview?.hostObjects?.schedulumHost;
const isWindowApp = navigator.userAgent.includes("SchedulumWinApp");

const isMacOSApp = window.webkit?.messageHandlers;

async function notifyWindows(title: string, msg: string) {
    if (typeof window !== "undefined" && (window as any).CefSharp && typeof (window as any).CefSharp.BindObjectAsync === "function") {
        await (window as any).CefSharp.BindObjectAsync("bridgeNotificationAsync");
        // Appel direct de la fonction C#
        if ((window as any).bridgeNotificationAsync && typeof (window as any).bridgeNotificationAsync.sendNotification === "function") {
            (window as any).bridgeNotificationAsync.sendNotification(title, msg);
        }
    }
}

const subscribeToTopicsNative = () => {
  // const actionData = { 
  //   action: "subscribeTopic", 
  //   topics: ["global", "posts"] 
  // };
  // if (window.webkit?.messageHandlers?.callbackHandler) {
  //     window.webkit.messageHandlers.callbackHandler.postMessage(actionData);
  //     // console.log("MacOS: Demande d'abonnement envoyée");
  // } 
  // else if (window.chrome?.webview?.hostObjects?.schedulumHost) {
  //     window.chrome.webview.hostObjects.schedulumHost.SubscribeToTopics(JSON.stringify(actionData));
  //     // console.log("Windows: Demande d'abonnement envoyée");
  // } else {
  //     console.log("Navigateur standard : Aucune action native disponible");
  // }
  if (window.webkit?.messageHandlers?.callbackHandler) {
      // On demande au Mac de s'abonner aux topics
      window.webkit.messageHandlers.callbackHandler.postMessage({ 
          action: "subscribeTopic", 
          topic: "global" 
      });
      
      window.webkit.messageHandlers.callbackHandler.postMessage({ 
          action: "subscribeTopic", 
          topic: "posts" 
      });
      
      console.log("MacOS system ask for topic subscriptions");
  }
};

/* SEO */
const injectLinkCanonical = (path: string) => {
  document.querySelectorAll('link[rel="canonical"]').forEach(el => el.remove());

  const link = document.createElement('link');
  link.setAttribute('rel', 'canonical');
  link.setAttribute('href', `https://schedulum.org/${path != undefined ? path : ''}`);

  document.head.appendChild(link);
}

function injectSchemaMarkup(t:any, lang: string, path: string, ratingValue: string, reviewCount: string) {
    let structuredData = {};
    switch(path) {
      case('news'):
        structuredData = {
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": t('meta.markupNameNews'),
          "description": t('meta.markupDescriptionNews'),
          "applicationCategory": "BusinessApplication",
          "operatingSystem": ["Android", "iOS", "Web"],
          "url": "https://schedulum.org/" + path ? path : '',
          
          "offers": {
              "@type": "Offer",
              // "url": "https://schedulum.org/details#pricing",
              "price": "15.00", 
              "priceCurrency": "CAD",
              "availability": "https://schema.org/InStock"
          },

          "featureList": [
            "Schedule management",
            "Timekeeping (Clock-in/Clock-out)",
            "Leave and absence management",
            "Team communication"
          ],

          "downloadUrl": "https://apps.apple.com/us/app/schedulum-app/id6746083873", 
          "inLanguage": "fr-FR",

          "aggregateRating": {
            "@type": "AggregateRating",
            // Ces valeurs doivent correspondre aux notes réelles sur les stores !
            "ratingValue": ratingValue, // Votre note moyenne (sur 5)
            "reviewCount": reviewCount // Le nombre total d'avis
          },
          // ... autres propriétés Schema.org si nécessaire
          "publisher": {
              "@type": "Organization",
              "name": "Schedulum"
          }
        };
        break;
      case('actualites'):
        structuredData = {
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": t('meta.markupNameNews'),
          "description": t('meta.markupDescriptionNews'),
          "applicationCategory": "BusinessApplication",
          "operatingSystem": ["Android", "iOS", "Web"],
          "url": "https://schedulum.org/" + path ? path : '',
          
          "offers": {
              "@type": "Offer",
              // "url": "https://schedulum.org/details#pricing",
              "price": "15.00", 
              "priceCurrency": "CAD",
              "availability": "https://schema.org/InStock"
          },

          "featureList": [
            "Schedule management",
            "Timekeeping (Clock-in/Clock-out)",
            "Leave and absence management",
            "Team communication"
          ],

          "downloadUrl": "https://apps.apple.com/us/app/schedulum-app/id6746083873", 
          "inLanguage": "fr-FR",

          "aggregateRating": {
            "@type": "AggregateRating",
            // Ces valeurs doivent correspondre aux notes réelles sur les stores !
            "ratingValue": ratingValue, // Votre note moyenne (sur 5)
            "reviewCount": reviewCount // Le nombre total d'avis
          },
          // ... autres propriétés Schema.org si nécessaire
          "publisher": {
              "@type": "Organization",
              "name": "Schedulum"
          }
        };
        break;
      case('help'):
        structuredData = {
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": t('meta.markupNameHelp'),
          "description": t('meta.markupDescriptionHelp'),
          "applicationCategory": "BusinessApplication",
          "operatingSystem": ["Android", "iOS", "Web"],
          "url": "https://schedulum.org/" + path ? path : '',
          
          "offers": {
              "@type": "Offer",
              // "url": "https://schedulum.org/details#pricing",
              "price": "15.00", 
              "priceCurrency": "CAD",
              "availability": "https://schema.org/InStock"
          },

          "featureList": [
            "Schedule management",
            "Timekeeping (Clock-in/Clock-out)",
            "Leave and absence management",
            "Team communication"
          ],

          "downloadUrl": "https://apps.apple.com/us/app/schedulum-app/id6746083873", 
          "inLanguage": "fr-FR",

          "aggregateRating": {
            "@type": "AggregateRating",
            // Ces valeurs doivent correspondre aux notes réelles sur les stores !
            "ratingValue": ratingValue, // Votre note moyenne (sur 5)
            "reviewCount": reviewCount // Le nombre total d'avis
          },
          // ... autres propriétés Schema.org si nécessaire
          "publisher": {
              "@type": "Organization",
              "name": "Schedulum"
          }
        };
        break;
      case('aide'):
        structuredData = {
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": t('meta.markupNameHelp'),
          "description": t('meta.markupDescriptionHelp'),
          "applicationCategory": "BusinessApplication",
          "operatingSystem": ["Android", "iOS", "Web"],
          "url": "https://schedulum.org/" + path ? path : '',
          
          "offers": {
              "@type": "Offer",
              // "url": "https://schedulum.org/details#pricing",
              "price": "15.00", 
              "priceCurrency": "CAD",
              "availability": "https://schema.org/InStock"
          },

          "featureList": [
            "Schedule management",
            "Timekeeping (Clock-in/Clock-out)",
            "Leave and absence management",
            "Team communication"
          ],

          "downloadUrl": "https://apps.apple.com/us/app/schedulum-app/id6746083873", 
          "inLanguage": "fr-FR",

          "aggregateRating": {
            "@type": "AggregateRating",
            // Ces valeurs doivent correspondre aux notes réelles sur les stores !
            "ratingValue": ratingValue, // Votre note moyenne (sur 5)
            "reviewCount": reviewCount // Le nombre total d'avis
          },
          // ... autres propriétés Schema.org si nécessaire
          "publisher": {
              "@type": "Organization",
              "name": "Schedulum"
          }
        };
        break;
      case('inscription'):
        structuredData = {
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": t('meta.markupNameSignUp'),
          "description": t('meta.markupDescriptionSignUp'),
          "applicationCategory": "BusinessApplication",
          "operatingSystem": ["Android", "iOS", "Web"],
          "url": "https://schedulum.org/" + path ? path : '',
          
          "offers": {
              "@type": "Offer",
              // "url": "https://schedulum.org/details#pricing",
              "price": "15.00", 
              "priceCurrency": "CAD",
              "availability": "https://schema.org/InStock"
          },

          "featureList": [
            "Schedule management",
            "Timekeeping (Clock-in/Clock-out)",
            "Leave and absence management",
            "Team communication"
          ],

          "downloadUrl": "https://apps.apple.com/us/app/schedulum-app/id6746083873", 
          "inLanguage": "fr-FR",

          "aggregateRating": {
            "@type": "AggregateRating",
            // Ces valeurs doivent correspondre aux notes réelles sur les stores !
            "ratingValue": ratingValue, // Votre note moyenne (sur 5)
            "reviewCount": reviewCount // Le nombre total d'avis
          },
          // ... autres propriétés Schema.org si nécessaire
          "publisher": {
              "@type": "Organization",
              "name": "Schedulum"
          }
        };
        break;
      case('confirmEmail'):
        structuredData = {
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": t('meta.markupNameConfirmEmail'),
          "description": t('meta.markupDescriptionConfirmEmail'),
          "applicationCategory": "BusinessApplication",
          "operatingSystem": ["Android", "iOS", "Web"],
          "url": "https://schedulum.org/" + path ? path : '',
          
          "offers": {
              "@type": "Offer",
              // "url": "https://schedulum.org/details#pricing",
              "price": "15.00", 
              "priceCurrency": "CAD",
              "availability": "https://schema.org/InStock"
          },

          "featureList": [
            "Schedule management",
            "Timekeeping (Clock-in/Clock-out)",
            "Leave and absence management",
            "Team communication"
          ],

          "downloadUrl": "https://apps.apple.com/us/app/schedulum-app/id6746083873", 
          "inLanguage": "fr-FR",

          "aggregateRating": {
            "@type": "AggregateRating",
            // Ces valeurs doivent correspondre aux notes réelles sur les stores !
            "ratingValue": ratingValue, // Votre note moyenne (sur 5)
            "reviewCount": reviewCount // Le nombre total d'avis
          },
          // ... autres propriétés Schema.org si nécessaire
          "publisher": {
              "@type": "Organization",
              "name": "Schedulum"
          }
        };
        break;
      case('confirmationCourriel'):
        structuredData = {
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": t('meta.markupNameConfirmEmail'),
          "description": t('meta.markupDescriptionConfirmEmail'),
          "applicationCategory": "BusinessApplication",
          "operatingSystem": ["Android", "iOS", "Web"],
          "url": "https://schedulum.org/" + path ? path : '',
          
          "offers": {
              "@type": "Offer",
              // "url": "https://schedulum.org/details#pricing",
              "price": "15.00", 
              "priceCurrency": "CAD",
              "availability": "https://schema.org/InStock"
          },

          "featureList": [
            "Schedule management",
            "Timekeeping (Clock-in/Clock-out)",
            "Leave and absence management",
            "Team communication"
          ],

          "downloadUrl": "https://apps.apple.com/us/app/schedulum-app/id6746083873", 
          "inLanguage": "fr-FR",

          "aggregateRating": {
            "@type": "AggregateRating",
            // Ces valeurs doivent correspondre aux notes réelles sur les stores !
            "ratingValue": ratingValue, // Votre note moyenne (sur 5)
            "reviewCount": reviewCount // Le nombre total d'avis
          },
          // ... autres propriétés Schema.org si nécessaire
          "publisher": {
              "@type": "Organization",
              "name": "Schedulum"
          }
        };
        break;
      case('details'):
        structuredData = {
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": t('meta.markupNameDetails'),
          "description": t('meta.markupDescriptionDetails'),
          "applicationCategory": "BusinessApplication",
          "operatingSystem": ["Android", "iOS", "Web"],
          "url": "https://schedulum.org/" + path ? path : '',
          
          "offers": {
              "@type": "Offer",
              // "url": "https://schedulum.org/details#pricing",
              "price": "15.00", 
              "priceCurrency": "CAD",
              "availability": "https://schema.org/InStock"
          },

          "featureList": [
            "Schedule management",
            "Timekeeping (Clock-in/Clock-out)",
            "Leave and absence management",
            "Team communication"
          ],

          "downloadUrl": "https://apps.apple.com/us/app/schedulum-app/id6746083873", 
          "inLanguage": "fr-FR",

          "aggregateRating": {
            "@type": "AggregateRating",
            // Ces valeurs doivent correspondre aux notes réelles sur les stores !
            "ratingValue": ratingValue, // Votre note moyenne (sur 5)
            "reviewCount": reviewCount // Le nombre total d'avis
          },
          // ... autres propriétés Schema.org si nécessaire
          "publisher": {
              "@type": "Organization",
              "name": "Schedulum"
          }
        };
        break;
      default:
        structuredData = {
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": t('meta.markupName'),
          "description": t('meta.markupDescription'),
          "applicationCategory": "BusinessApplication",
          "operatingSystem": ["Android", "iOS", "Web"],
          "url": "https://schedulum.org/" + path ? path : '',
          
          "offers": {
              "@type": "Offer",
              // "url": "https://schedulum.org/details#pricing",
              "price": "15.00", 
              "priceCurrency": "CAD",
              "availability": "https://schema.org/InStock"
          },

          "featureList": [
            "Schedule management",
            "Timekeeping (Clock-in/Clock-out)",
            "Leave and absence management",
            "Team communication"
          ],

          "downloadUrl": "https://apps.apple.com/us/app/schedulum-app/id6746083873", 
          "inLanguage": "fr-FR",

          "aggregateRating": {
            "@type": "AggregateRating",
            // Ces valeurs doivent correspondre aux notes réelles sur les stores !
            "ratingValue": ratingValue, // Votre note moyenne (sur 5)
            "reviewCount": reviewCount // Le nombre total d'avis
          },
          // ... autres propriétés Schema.org si nécessaire
          "publisher": {
              "@type": "Organization",
              "name": "Schedulum"
          }
        };
    }

    // 2. Créer l'élément Script
    const script = document.createElement('script');
    script.setAttribute('type', 'application/ld+json');
    script.setAttribute('id', 'schedulum-schema-ld');

    // 3. Convertir l'objet JSON en chaîne de caractères
    script.textContent = JSON.stringify(structuredData);

    // 4. Injecter dans le <head>
    document.head.appendChild(script);
}

const injectSEOHeadContent = (t: any, lang: string) => {
  const path = window.location.pathname.split('/').filter(Boolean).pop();
  switch(path) {
    case('news'):
      document.querySelector('meta[name="description"]')
        ?.setAttribute('content', `${t('meta.descriptionNews')}`);
      document.querySelector('meta[property="og:title"]')
        ?.setAttribute('content', `${t('meta.ogTitleNews')}`);
      document.querySelector('meta[property="og:description"]')
        ?.setAttribute('content', `${t('meta.ogDescriptionNews')}`);
      document.querySelector('meta[property="og:type"]')
        ?.setAttribute('content', `${t('meta.ogTypeNews')}`);
      document.querySelector('meta[property="og:url"]')
        ?.setAttribute('content', t('meta.ogUrlNews'));
      document.querySelector('meta[property="og:image"]')
        ?.setAttribute('content', `${t('meta.ogImageNews')}`);
      document.querySelector('meta[name="twitter:card"]')
        ?.setAttribute('content', `${t('meta.ogImageNews')}`);
      break;
    case('actualites'):
      document.querySelector('meta[name="description"]')
        ?.setAttribute('content', `${t('meta.descriptionNews')}`);
      document.querySelector('meta[property="og:title"]')
        ?.setAttribute('content', `${t('meta.ogTitleNews')}`);
      document.querySelector('meta[property="og:description"]')
        ?.setAttribute('content', `${t('meta.ogDescriptionNews')}`);
      document.querySelector('meta[property="og:type"]')
        ?.setAttribute('content', `${t('meta.ogTypeNews')}`);
      document.querySelector('meta[property="og:url"]')
        ?.setAttribute('content', `${t('meta.ogUrlNews')}`);
      document.querySelector('meta[property="og:image"]')
        ?.setAttribute('content', `${t('meta.ogImageNews')}`);
      document.querySelector('meta[name="twitter:card"]')
        ?.setAttribute('content', `${t('meta.ogImageNews')}`);
      break;
    case('help'):
      document.querySelector('meta[name="description"]')
        ?.setAttribute('content', `${t('meta.descriptionHelp')}`);
      document.querySelector('meta[property="og:title"]')
        ?.setAttribute('content', `${t('meta.ogTitleHelp')}`);
      document.querySelector('meta[property="og:description"]')
        ?.setAttribute('content', `${t('meta.ogDescriptionHelp')}`);
      document.querySelector('meta[property="og:type"]')
        ?.setAttribute('content', `${t('meta.ogTypeHelp')}`);
      document.querySelector('meta[property="og:url"]')
        ?.setAttribute('content', t('meta.ogUrlHelp'));
      document.querySelector('meta[property="og:image"]')
        ?.setAttribute('content', `${t('meta.ogImageHelp')}`);
      document.querySelector('meta[name="twitter:card"]')
        ?.setAttribute('content', `${t('meta.ogImageHelp')}`);
      break;
    case('aide'):
      document.querySelector('meta[name="description"]')
        ?.setAttribute('content', `${t('meta.descriptionHelp')}`);
      document.querySelector('meta[property="og:title"]')
        ?.setAttribute('content', `${t('meta.ogTitleHelp')}`);
      document.querySelector('meta[property="og:description"]')
        ?.setAttribute('content', `${t('meta.ogDescriptionHelp')}`);
      document.querySelector('meta[property="og:type"]')
        ?.setAttribute('content', `${t('meta.ogTypeHelp')}`);
      document.querySelector('meta[property="og:url"]')
        ?.setAttribute('content', t('meta.ogUrlHelp'));
      document.querySelector('meta[property="og:image"]')
        ?.setAttribute('content', `${t('meta.ogImageHelp')}`);
      document.querySelector('meta[namey="twitter:card"]')
        ?.setAttribute('content', `${t('meta.ogImageHelp')}`);
      break;
    case('signup'):
      document.querySelector('meta[name="description"]')
        ?.setAttribute('content', `${t('meta.descriptionSignUp')}`);
      document.querySelector('meta[property="og:title"]')
        ?.setAttribute('content', `${t('meta.ogTitleSignUp')}`);
      document.querySelector('meta[property="og:description"]')
        ?.setAttribute('content', `${t('meta.ogDescriptionSignUp')}`);
      document.querySelector('meta[property="og:type"]')
        ?.setAttribute('content', `${t('meta.ogTypeSignUp')}`);
      document.querySelector('meta[property="og:url"]')
        ?.setAttribute('content', t('meta.ogUrlSignUp'));
      document.querySelector('meta[property="og:image"]')
        ?.setAttribute('content', `${t('meta.ogImageSignUp')}`);
      document.querySelector('meta[name="twitter:card"]')
        ?.setAttribute('content', `${t('meta.ogImageSignUp')}`);
      break;
    case('inscription'):
      document.querySelector('meta[name="description"]')
        ?.setAttribute('content', `${t('meta.descriptionSignUp')}`);
      document.querySelector('meta[property="og:title"]')
        ?.setAttribute('content', `${t('meta.ogTitleSignUp')}`);
      document.querySelector('meta[property="og:description"]')
        ?.setAttribute('content', `${t('meta.ogDescriptionSignUp')}`);
      document.querySelector('meta[property="og:type"]')
        ?.setAttribute('content', `${t('meta.ogTypeSignUp')}`);
      document.querySelector('meta[property="og:url"]')
        ?.setAttribute('content', t('meta.ogUrlSignUp'));
      document.querySelector('meta[property="og:image"]')
        ?.setAttribute('content', `${t('meta.ogImageSignUp')}`);
      document.querySelector('meta[name="twitter:card"]')
        ?.setAttribute('content', `${t('meta.ogImageSignUp')}`);
      break;
    case('confirmEmail'):
      document.querySelector('meta[name="description"]')
        ?.setAttribute('content', `${t('meta.descriptionConfirmEmail')}`);
      document.querySelector('meta[property="og:title"]')
        ?.setAttribute('content', `${t('meta.ogTitleConfirmEmail')}`);
      document.querySelector('meta[property="og:description"]')
        ?.setAttribute('content', `${t('meta.ogDescriptionConfirmEmail')}`);
      document.querySelector('meta[property="og:type"]')
        ?.setAttribute('content', `${t('meta.ogTypeConfirmEmail')}`);
      document.querySelector('meta[property="og:url"]')
        ?.setAttribute('content', t('meta.ogUrlConfirmEmail'));
      document.querySelector('meta[property="og:image"]')
        ?.setAttribute('content', `${t('meta.ogImageConfirmEmail')}`);
      document.querySelector('meta[name="twitter:card"]')
        ?.setAttribute('content', `${t('meta.ogImageConfirmEmail')}`);
      break;
    case('confirmationCourriel'):
      document.querySelector('meta[name="description"]')
        ?.setAttribute('content', `${t('meta.descriptionConfirmEmail')}`);
      document.querySelector('meta[property="og:title"]')
        ?.setAttribute('content', `${t('meta.ogTitleConfirmEmail')}`);
      document.querySelector('meta[property="og:description"]')
        ?.setAttribute('content', `${t('meta.ogDescriptionConfirmEmail')}`);
      document.querySelector('meta[property="og:type"]')
        ?.setAttribute('content', `${t('meta.ogTypeConfirmEmail')}`);
      document.querySelector('meta[property="og:url"]')
        ?.setAttribute('content', t('meta.ogUrlConfirmEmail'));
      document.querySelector('meta[property="og:image"]')
        ?.setAttribute('content', `${t('meta.ogImageConfirmEmail')}`);
      document.querySelector('meta[name="twitter:card"]')
        ?.setAttribute('content', `${t('meta.ogImageConfirmEmail')}`);
      break;
    case('details'):
      document.querySelector('meta[name="description"]')
        ?.setAttribute('content', `${t('meta.descriptionDetails')}`);
      document.querySelector('meta[property="og:title"]')
        ?.setAttribute('content', `${t('meta.ogTitleDetails')}`);
      document.querySelector('meta[property="og:description"]')
        ?.setAttribute('content', `${t('meta.ogDescriptionDetails')}`);
      document.querySelector('meta[property="og:type"]')
        ?.setAttribute('content', `${t('meta.ogTypeDetails')}`);
      document.querySelector('meta[property="og:url"]')
        ?.setAttribute('content', t('meta.ogUrlDetails'));
      document.querySelector('meta[property="og:image"]')
        ?.setAttribute('content', `${t('meta.ogImageDetails')}`);
      document.querySelector('meta[name="twitter:card"]')
        ?.setAttribute('content', `${t('meta.ogImageDetails')}`);
      break;
    default:
      document.querySelector('meta[name="description"]')
        ?.setAttribute('content', `${t('meta.description')}`);
      document.querySelector('meta[property="og:title"]')
        ?.setAttribute('content', `${t('meta.ogTitle')}`);
      document.querySelector('meta[property="og:description"]')
        ?.setAttribute('content', `${t('meta.ogDescription')}`);
      document.querySelector('meta[property="og:type"]')
        ?.setAttribute('content', `${t('meta.ogType')}`);
      document.querySelector('meta[property="og:url"]')
        ?.setAttribute('content', t('meta.ogUrl'));
      document.querySelector('meta[property="og:image"]')
        ?.setAttribute('content', `${t('meta.ogImage')}`);
      document.querySelector('meta[name="twitter:card"]')
        ?.setAttribute('content', `${t('meta.ogImage')}`);
  }

  injectLinkCanonical(path);
  injectSchemaMarkup(t, lang, path, "4.8", "210");
}
/* SEO */

const changeLanguage = (lang: string) => {
  i18n.changeLanguage(lang); // Change la langue ici
  Cookies.set('language', lang, { expires: 365 });
};

// Cognito username = email
type SignInData = {
  username: string;
  password: string;
};

// const RenderNavBar = (user?: AuthUser, client?: any) => {
interface RenderNavBarProps {
  user: AuthUser;
  client: any;
}

const RenderNavBar: React.FC<RenderNavBarProps> = ({ user, client }) => {
  // CLIENT
  const clientRef = useRef(client);
  // I18N
  const { t } = useTranslation();
  // LOADING
  const [loading, setLoading] = useState(false);
  // NAVIGATION
  const navigate = useNavigate();
  const location = useLocation();
  // FORM
  const {register, control, handleSubmit, reset} = useForm<SignInData>();
  // FCM NOTIFICATION LOCAL STORAGE
  // const FCMToken = localStorage.getItem("FCMToken");
  // const postNotifCount = localStorage.getItem("post");
  // const stored = localStorage.getItem("notifications");
  // const notifs = stored ? JSON.parse(stored) : [];
  // console.log("🔔 Notifs sauvegardées :", notifs);
  // NOTIFICATION COUNT STORAGE
  const notificationContext = useNotification();
  const notificationCount = notificationContext?.notificationCount;
  const setNotificationCount = notificationContext?.setNotificationCount;
  const shiftCount = notificationContext?.shiftCount;
  const setShiftCount = notificationContext?.setShiftCount;
  const shiftAcceptedCount = notificationContext?.shiftAcceptedCount;
  const setShiftAcceptedCount = notificationContext?.setShiftAcceptedCount;
  const openShiftCount = notificationContext?.openShiftCount;
  const setOpenShiftCount = notificationContext?.setOpenShiftCount;
  const openShiftAcceptedCount = notificationContext?.openShiftAcceptedCount;
  const setOpenShiftAcceptedCount = notificationContext?.setOpenShiftAcceptedCount;
  const confirmShiftCount = notificationContext?.confirmShiftCount;
  const setConfirmShiftCount = notificationContext?.setConfirmShiftCount;
  const documentCount = notificationContext?.documentCount;
  const setDocumentCount = notificationContext?.setDocumentCount;
  const swapRequestCount = notificationContext?.swapRequestCount;
  const setSwapRequestCount = notificationContext?.setSwapRequestCount;
  const leaveRequestCount = notificationContext?.leaveRequestCount;
  const setLeaveRequestCount = notificationContext?.setLeaveRequestCount;
  const postCount = notificationContext?.postCount;
  const setPostCount = notificationContext?.setPostCount;
  const postLink = notificationContext?.postLink;
  const setPostLink = notificationContext?.setPostLink;
  const shiftLink = notificationContext?.shiftLink;
  const setShiftLink = notificationContext?.setShiftLink;
  const openShiftLink = notificationContext?.openShiftLink;
  const setOpenShiftLink = notificationContext?.setOpenShiftLink;
  const confirmShiftLink = notificationContext?.confirmShiftLink;
  const setConfirmShiftLink = notificationContext?.setConfirmShiftLink;

  const {saveNotificationModelCount, getNotificationModelCount, 
    updateNotificationModelCount, updateNotificationModelLink} = useNotificationStorageService();

  // async function getNotificationModelCountFunction(model: string) {
  //   try {
  //       const ret_string = localStorage.getItem(model);
  //       const ret = ret_string ? JSON.parse(ret_string) : "";
  //       if (model == 'post') {
  //           setPostCount && setPostCount(ret.count);
  //       } else if (model == 'openShift') {
  //           setOpenShiftCount && setOpenShiftCount(ret.count);
  //       } else if (model == 'openShiftAccepted') {
  //           setOpenShiftAcceptedCount && setOpenShiftAcceptedCount(ret.count);
  //       } else if (model == 'shift') {
  //           setShiftCount && setShiftCount(ret.count);
  //       } else if (model == 'shiftAccepted') {
  //           setShiftAcceptedCount && setShiftAcceptedCount(ret.count);
  //       } else if (model == 'confirmShift') {
  //           setConfirmShiftCount && setConfirmShiftCount(ret.count);
  //       } else if (model == 'document') {
  //           setDocumentCount && setDocumentCount(ret.count);
  //       } else if (model == 'swapRequest') {
  //           setSwapRequestCount && setSwapRequestCount(ret.count);
  //       } else if (model == 'leaveRequest') {
  //           setLeaveRequestCount && setLeaveRequestCount(ret.count);
  //       }
  //       return ret.count || 0;
  //   } catch (err) {
  //       console.warn((err: any) => err.message);
  //       if (model == 'post') {
  //           setPostCount && setPostCount(0);
  //       } else if (model == 'openShift') {
  //           setOpenShiftCount && setOpenShiftCount(0);
  //       } else if (model == 'openShiftAccepted') {
  //           setOpenShiftAcceptedCount && setOpenShiftAcceptedCount(0);
  //       } else if (model == 'shift') {
  //           setShiftCount && setShiftCount(0);
  //       } else if (model == 'shiftAccepted') {
  //           setShiftAcceptedCount && setShiftAcceptedCount(0);
  //       } else if (model == 'confirmShift') {
  //           setConfirmShiftCount && setConfirmShiftCount(0);
  //       } else if (model == 'document') {
  //           setDocumentCount && setDocumentCount(0);
  //       } else if (model == 'swapRequest') {
  //           setSwapRequestCount && setSwapRequestCount(0);
  //       } else if (model == 'leaveRequest') {
  //           setLeaveRequestCount && setLeaveRequestCount(0);
  //       }
  //       return 0; // Return 0 if error
  //   }
  // }

  async function getNotificationModelLink(model: string) {
    try {
      // localStorage.clear();
      // console.log(model);
      const ret_string = localStorage.getItem(model);
      const ret = ret_string ? JSON.parse(ret_string) : "";
     
      if (model == 'postLink') {
        if (ret.link == 'post') {
          updateNotificationModelLink("postLink", "");
          navigate(t('link.posts'), { replace: true, state: {} });
          // navigate('/posts', { replace: true, state: {} });
        } else if (ret?.link == 'chatter') {
          updateNotificationModelLink("postLink", "");
          navigate(`${t('link.posts')}/${ret.senderId}`, { replace: true, state: {} });
          // navigate('/posts/', { replace: true, state: {} });
        }
      } else if (model == 'openShiftLink') {
        if (ret.link == 'openShift') {
          updateNotificationModelLink("openShiftLink", "");
          if (client?.type === "MANAGER") {
            navigate(`${t('link.scheduler')}${t('link.open_shifts')}`, { replace: true, state: {} });
          } else {
            // if (ret.senderId == PUBLIC_ID) {
            //     navigate('/open_shifts/public', { replace: true, state: {} });
            // } else {
            //     navigate('/open_shifts', { replace: true, state: {} });
            // }
            navigate(t('link.open_shifts'), { replace: true, state: {} });
          }
        }
      } else if (model == 'shiftLink') {
        if (ret.link == 'shift') {
          updateNotificationModelLink("shiftLink", "");
          if (client?.type === "MANAGER") {
            navigate(t('link.shifts'), { replace: true, state: {} });
          } else {
            navigate(t('link.shifts'), { replace: true, state: {} });
          }
        }
      } else if (model == 'confirmShiftLink') {
        if (ret.link == 'confirmShift') {
          updateNotificationModelLink("confirmShiftLink", "");
          if (client?.type === "MANAGER") {
            navigate(t('link.scheduler'), { replace: true, state: {} });
          } else {
            navigate('/agenda', { replace: true, state: {} });
          }
        }
      } else if (model == 'documentLink') {
        updateNotificationModelLink("documentLink", "");
        if (ret.link == 'document') {
          navigate('/documents', { replace: true, state: {} });
        }
      } else if (model == 'swapRequestLink') {
        updateNotificationModelLink("swapRequestLink", "");
        if (ret.link == 'swapRequest') {
          navigate(t('link.requests_swap'), { replace: true, state: {} });
        }
      } else if (model == 'leaveRequestLink') {
        updateNotificationModelLink("leaveRequestLink", "");
        if (ret.link == 'leaveRequest') {
          navigate(t('link.requests_leave'), { replace: true, state: {} });
        }
      }
      return ret.link || "";
    } catch (err) {
      console.warn(err);
      // if (model == 'post') {
      //   setPostCount && setPostCount(0);
      // } else if (model == 'openShift') {
      //   setOpenShiftCount && setOpenShiftCount(0);
      // } else if (model == 'shift') {
      //   setShiftCount && setShiftCount(0);
      // } else if (model == 'confirmShift') {
      //   setConfirmShiftCount && setConfirmShiftCount(0);
      // } else if (model == 'document') {
      //   setDocumentCount && setDocumentCount(0);
      // } else if (model == 'swapRequest') {
      //   setSwapRequestCount && setSwapRequestCount(0);
      // } else if (model == 'leaveRequest') {
      //   setLeaveRequestCount && setLeaveRequestCount(0);
      // }
      return "";
    }
  }

  // async function getLinkOnlyWithNotificationModelLink(model: string) {
  //     try {
  //         const ret_string = localStorage.getItem(model);
  //         const ret = ret_string ? JSON.parse(ret_string) : "";

  //         if (model == 'postLink') {
  //             if (ret.link == 'chatter') {
  //                 setPostLink && setPostLink(ret.senderId);
  //                 updateNotificationModelLink("postLink", "");
  //             }
  //         } else if (model == 'shiftLink' || model == 'openShiftLink' || model == 'confirmShiftLink') {
  //             if (ret.link == 'shift') {
  //                 if (ret.startAt) {
  //                     setShiftLink && setShiftLink(ret.startAt);
  //                     updateNotificationModelLink("shiftLink", "");
  //                 }
  //             } else if (ret.link == 'openShift') {
  //                 if (ret.startAt) {
  //                     setOpenShiftLink && setOpenShiftLink(ret.startAt);
  //                     updateNotificationModelLink("opnShiftLink", "");
  //                 }
  //             } else if (ret.link == 'confirmShift') {
  //                 if (ret.startAt) {
  //                     setConfirmShiftLink && setConfirmShiftLink(ret.startAt);
  //                     updateNotificationModelLink("confirmShiftLink", "");
  //                 }
  //             }
  //         }
  //         return ret.count || 0;
  //     } catch (err) {
  //         console.warn((err: any) => err.message);
  //         if (model == 'post') {
  //             setPostCount && setPostCount(0);
  //         } else if (model == 'openShift') {
  //             setOpenShiftCount && setOpenShiftCount(0);
  //         } else if (model == 'shift') {
  //             setShiftCount && setShiftCount(0);
  //         } else if (model == 'confirmShift') {
  //             setConfirmShiftCount && setConfirmShiftCount(0);
  //         } else if (model == 'document') {
  //             setDocumentCount && setDocumentCount(0);
  //         } else if (model == 'swapRequest') {
  //             setSwapRequestCount && setSwapRequestCount(0);
  //         } else if (model == 'leaveRequest') {
  //             setLeaveRequestCount && setLeaveRequestCount(0);
  //         }
  //         return 0;
  //     }
  // }

  const getAllModelCount = async () => {
    const counts = await Promise.all([
        getNotificationModelCount("post"),
        getNotificationModelCount("openShift"),
        getNotificationModelCount("openShiftAccepted"),
        getNotificationModelCount("shift"),
        getNotificationModelCount("shiftAccepted"),
        getNotificationModelCount("confirmShift"),
        getNotificationModelCount("document"),
        getNotificationModelCount("swapRequest"),
        getNotificationModelCount("leaveRequest"),
    ]);

    const total = counts.reduce((acc, count) => acc + count, 0);
    updateNotificationModelCount('notification', total);
    setNotificationCount && setNotificationCount(total);
  };

  useEffect(() => {
      (async () => {
          await getAllModelCount();
      })();
  }, [postCount, openShiftCount, openShiftAcceptedCount, confirmShiftCount, shiftCount,
      shiftAcceptedCount, documentCount, swapRequestCount, leaveRequestCount]);

  const checkForLink = async () => {
    // Link
    getNotificationModelLink("shiftLink");
    getNotificationModelLink("confirmShiftLink");
    getNotificationModelLink("openShiftLink");
    // getNotificationModelLink("documentLink");
    // getNotificationModelLink("swapRequestLink");
    // getNotificationModelLink("leaveRequestLink");
    getNotificationModelLink("postLink");
  };

  // useEffect(() => {
  //   if (!client || !client.type) return;
  //   clientRef.current = client;
  //   setTimeout(checkForLink, 1000);
  //   // if (!user.comId) return
  //   // subscribeToTopics(user.comId, user.userId);
  // }, [client]);

  // useEffect(() => {
  //   const unsubscribe = messaging().onMessage(async remoteMessage => {
  //       if (remoteMessage.data) {
  //           const dataObject = Object.keys(remoteMessage.data)[0];
  //           const data = JSON.parse(dataObject);
  //           if (data.type && data.senderId) {
  //               if (data.type == "post") {
  //                   const senderId = data.senderId;
  //                   // Bloc notification
  //                   if (senderId === AuthUserId) {
  //                       console.log("Notification bloquée car elle vient de l'expéditeur.");
  //                       return;
  //                   }
  //               }
  //           }
        
  //           // Afficher la notification
  //           console.log("Nouvelle notification :", remoteMessage);
  //       }
  //   });
  
  //   return unsubscribe; // Se désinscrire au démontage du composant
  // }, []);

  const goToBestNotification = () => {
    const post = postCount ? postCount : 0;
    const openShift = openShiftCount ? openShiftCount : 0;
    const openShiftAccepted = openShiftAcceptedCount ? openShiftAcceptedCount : 0;
    const shift = shiftCount ? shiftCount : 0;
    const shiftAccepted = shiftAcceptedCount ? shiftAcceptedCount : 0;
    const confirmShift = confirmShiftCount ? confirmShiftCount : 0;
    const document = documentCount ? documentCount : 0;
    const swapRequest = swapRequestCount ? swapRequestCount : 0;
    const leaveRequest = leaveRequestCount ? leaveRequestCount : 0;
    const notification = notificationCount ? notificationCount : 0;
    if (client?.type === "MANAGER") {
      if (shift > 0) {
        updateNotificationModelCount('shift', 0);
        setShiftCount && setShiftCount(0);
        updateNotificationModelCount('notification', notification-shift);
        setNotificationCount && setNotificationCount(notification-shift);
        navigate(t('link.shifts'));
      } else if (shiftAccepted > 0) {
        updateNotificationModelCount('shiftAccepted', 0);
        setShiftAcceptedCount && setShiftAcceptedCount(0);
        updateNotificationModelCount('notification', notification-shiftAccepted);
        setNotificationCount && setNotificationCount(notification-shiftAccepted);
        navigate(t('link.scheduler'));
      } else if (openShift > 0) {
        updateNotificationModelCount('openShift', 0);
        setOpenShiftCount && setOpenShiftCount(0);
        updateNotificationModelCount('notification', notification-openShift);
        setNotificationCount && setNotificationCount(notification-openShift);
        navigate(`${t('link.scheduler')}${t('link.open_shifts')}`);
      } else if (openShiftAccepted > 0) {
        updateNotificationModelCount('openShiftAccepted', 0);
        setOpenShiftAcceptedCount && setOpenShiftAcceptedCount(0);
        updateNotificationModelCount('notification', notification-openShiftAccepted);
        setNotificationCount && setNotificationCount(notification-openShiftAccepted);
        navigate(`${t('link.scheduler')}${t('link.open_shifts')}`);
      } else if (confirmShift > 0) {
        updateNotificationModelCount('confirmShift', 0);
        setConfirmShiftCount && setConfirmShiftCount(0);
        updateNotificationModelCount('notification', notification-confirmShift);
        setNotificationCount && setNotificationCount(notification-confirmShift);
        navigate(t('link.scheduler'));
      }
    } else {
      if (shift > 0) {
        updateNotificationModelCount('shift', 0);
        setShiftCount && setShiftCount(0);
        updateNotificationModelCount('notification', notification-shift);
        setNotificationCount && setNotificationCount(notification-shift);
        navigate(t('link.shifts'));
      } else if (shiftAccepted > 0) {
        updateNotificationModelCount('shiftAccepted', 0);
        setShiftAcceptedCount && setShiftAcceptedCount(0);
        updateNotificationModelCount('notification', notification-shiftAccepted);
        setNotificationCount && setNotificationCount(notification-shiftAccepted);
        navigate(t('link.shifts'));
      } else if (openShift > 0) {
        updateNotificationModelCount('openShift', 0);
        setOpenShiftCount && setOpenShiftCount(0);
        updateNotificationModelCount('notification', notification-openShift);
        setNotificationCount && setNotificationCount(notification-openShift);
        // if (openShiftLink && openShiftLink != "") {
        //     if (openShiftLink == PUBLIC_ID) {
        //         navigate('/open_shifts/public', { replace: true, state: { refetchData: true }  });
        //     } else {
        //         navigate('/open_shifts', { replace: true, state: { refetchData: true }  });
        //     }
        // } else {
        //     navigate('/open_shifts', { replace: true, state: { refetchData: true }  });
        // }
        navigate(t('link.open_shifts'), { replace: true, state: { refetchData: true }  });
      } else if (openShiftAccepted > 0) {
        updateNotificationModelCount('openShiftAccepted', 0);
        setOpenShiftAcceptedCount && setOpenShiftAcceptedCount(0);
        updateNotificationModelCount('notification', notification-openShiftAccepted);
        setNotificationCount && setNotificationCount(notification-openShiftAccepted);
        navigate(t('link.open_shifts'));
      } else if (confirmShift > 0) {
        updateNotificationModelCount('confirmShift', 0);
        setConfirmShiftCount && setConfirmShiftCount(0);
        updateNotificationModelCount('notification', notification-confirmShift);
        setNotificationCount && setNotificationCount(notification-confirmShift);
        navigate('/agenda');
      }
    }
    if (document > 0) {
      updateNotificationModelCount('document', 0);
      setDocumentCount && setDocumentCount(0);
      updateNotificationModelCount('notification', notification-document);
      setNotificationCount && setNotificationCount(notification-document);
      navigate('/documents');
    } else if (swapRequest > 0) {
      updateNotificationModelCount('swapRequest', 0);
      setSwapRequestCount && setSwapRequestCount(0);
      updateNotificationModelCount('notification', notification-swapRequest);
      setNotificationCount && setNotificationCount(notification-swapRequest);
      navigate(t('link.requests_swap'));
    } else if (leaveRequest > 0) {
      updateNotificationModelCount('leaveRequest', 0);
      setLeaveRequestCount && setLeaveRequestCount(0);
      updateNotificationModelCount('notification', notification-leaveRequest);
      setNotificationCount && setNotificationCount(notification-leaveRequest);
      navigate(t('link.requests_leave'));
    } else if (post > 0) {
      updateNotificationModelCount('post', 0);
      setPostCount && setPostCount(0);
      updateNotificationModelCount('notification', notification-post);
      setNotificationCount && setNotificationCount(notification-post);
      if (postLink && postLink != "") {
          navigate(`${t('link.posts')}/${postLink}`);
      } else {
          navigate(t('link.posts'));
      }
    }
  }

  async function updateModelCount(data: any, myTimeout?: any) {
    let model = "";
    switch(data) {
      case('post'):
          model = 'post';
          break;
      case('shift'):
          model = 'shift';
          break;
      case('shiftAccepted'):
          model = 'shiftAccepted';
          break;
      case('openShift'):
          model = 'openShift';
          break;
      case('openShiftAccepted'):
          model = 'openShiftAccepted';
          break;
      case('confirmShift'):
          model = 'confirmShift';
          break;
      case('document'):
          model = 'document';
          break;
      case('swapRequest'):
          model = 'swapRequest';
          break;
      case('leaveRequest'):
          model = 'leaveRequest';
          break;
    }
    // console.log('MODEL', data);
    const ret = localStorage.getItem(model);
    
    // console.log(model + ": " +parseInt(ret));
    const count = ret ? parseInt(ret) : 0;

    if (model == 'post') {
        setPostCount && setPostCount(count);
    } else if (model == 'openShift') {
        setOpenShiftCount && setOpenShiftCount(count);
    } else if (model == 'openShiftAccepted') {
        setOpenShiftAcceptedCount && setOpenShiftAcceptedCount(count);
    } else if (model == 'shift') {
        setShiftCount && setShiftCount(count);
    } else if (model == 'shiftAccepted') {
        setShiftAcceptedCount && setShiftAcceptedCount(count);
    } else if (model == 'confirmShift') {
        setConfirmShiftCount && setConfirmShiftCount(count);
    } else if (model == 'document') {
        setDocumentCount && setDocumentCount(count);
    } else if (model == 'swapRequest') {
      setSwapRequestCount && setSwapRequestCount(count);
    } else if (model == 'leaveRequest') {
      setLeaveRequestCount && setLeaveRequestCount(count);
    }
    // console.log(model+'_counts', count);
    if (myTimeout) {
      clearTimeout(myTimeout);
    }
  }

  const refreshNotifyModels = async (message: any) => {
    // console.log('messTTT ', message);

    // async function updateModelCount(data: any) {
    //   let model = "";
    //   switch(data) {
    //     case('post'):
    //         model = 'post';
    //         break;
    //     case('shift'):
    //         model = 'shift';
    //         break;
    //     case('shiftAccepted'):
    //         model = 'shiftAccepted';
    //         break;
    //     case('openShift'):
    //         model = 'openShift';
    //         break;
    //     case('openShiftAccepted'):
    //         model = 'openShiftAccepted';
    //         break;
    //     case('confirmShift'):
    //         model = 'confirmShift';
    //         break;
    //     case('document'):
    //         model = 'document';
    //         break;
    //     case('swapRequest'):
    //         model = 'swapRequest';
    //         break;
    //     case('leaveRequest'):
    //         model = 'leaveRequest';
    //         break;
    //   }
    // //   if (data.post) {
    // //     model = 'post';
    // //   } else if (data.openShift) {
    // //     model = 'openShift';
    // //   } else if (data.shift) {
    // //     model = 'shift';
    // //   } else if (data.confirmShift) {
    // //     model = 'confirmShift';
    // //   } else if (data.request) {
    // //     model = 'request';
    // //   }
    //   // console.log('MODEL', data);
    //   const ret = localStorage.getItem(model);
      
    //   // console.log(model + ": " +parseInt(ret));
    //   const count = ret ? parseInt(ret) : 0;
    //   // storage.load({
    //   //   key: model,
    //   //   autoSync: true,
    //   //   syncInBackground: true,
    //   //   syncParams:{extraFetchOptions:{}, someFlag: true}
    //   // })
    //   // .then(ret => {
    //   if (model == 'post') {
    //       setPostCount && setPostCount(count);
    //   } else if (model == 'openShift') {
    //       setOpenShiftCount && setOpenShiftCount(count);
    //   } else if (model == 'openShiftAccepted') {
    //       setOpenShiftAcceptedCount && setOpenShiftAcceptedCount(count);
    //   } else if (model == 'shift') {
    //       setShiftCount && setShiftCount(count);
    //   } else if (model == 'shiftAccepted') {
    //       setShiftAcceptedCount && setShiftAcceptedCount(count);
    //   } else if (model == 'confirmShift') {
    //       setConfirmShiftCount && setConfirmShiftCount(count);
    //   } else if (model == 'document') {
    //       setDocumentCount && setDocumentCount(count);
    //   } else if (model == 'swapRequest') {
    //     setSwapRequestCount && setSwapRequestCount(count);
    //   } else if (model == 'leaveRequest') {
    //     setLeaveRequestCount && setLeaveRequestCount(count);
    //   }
    //   // console.log(model+'_counts', count);
      
    //   clearTimeout(myTimeout);
    // }
    // const dataObject = Object.keys(message.data)[0];
    // const data = JSON.parse(dataObject);
    const data = message.data;
    const myTimeout = setTimeout(async () => await updateModelCount(data.type, myTimeout), 5000);
  }

  // useEffect(() => {
  //   // const unsubscribe = messaging().onMessage(refreshNotifyModels);
  //   // return unsubscribe;
  //   onMessage(messaging, (payload) => {
  //     console.log("Notification reçue en foreground :", payload);
  //     if (payload) {
  //         refreshNotifyModels(payload);
  //     }
  //   });
  // }, []);

  const buildNotifLocalStorage = async(payload: MessagePayload) => {
    // console.log("Notification reçue en foreground :", payload);
    if (payload.data.type == "post") {
      const amount = await getNotificationModelCount('post');
      await saveNotificationModelCount('post', amount);
      if (payload.data.id === "null") {
        setPostLink && setPostLink("");
      } else {
        setPostLink && setPostLink(payload.data.senderId);
      }
    } else if (payload.data.type == "shift") {
      const amount = await getNotificationModelCount('shift');
      await saveNotificationModelCount('shift', amount);
      if (payload.data.startAt) {
          setShiftLink && setShiftLink(payload.data.startAt);
      }
    } else if (payload.data.type == "shiftAccepted") {
      const amount = await getNotificationModelCount('shiftAccepted');
      await saveNotificationModelCount('shiftAccepted', amount);
    } else if (payload.data.type == "openShift") {
      const amount = await getNotificationModelCount('openShift');
      await saveNotificationModelCount('openShift', amount);
      if (payload.data.senderId == PUBLIC_ID) {
          setOpenShiftLink && setOpenShiftLink(payload.data.senderId);
      } else if (payload.data.startAt) {
          setOpenShiftLink && setOpenShiftLink(payload.data.startAt);
      }
    } else if (payload.data.type == "openShiftAccepted") {
      const amount = await getNotificationModelCount('openShiftAccepted');
      await saveNotificationModelCount('openShiftAccepted', amount);
    } else if (payload.data.type == "confirmShift") {
      const amount = await getNotificationModelCount('confirmShift');
      await saveNotificationModelCount('confirmShift', amount);
      if (payload.data.startAt) {
          setConfirmShiftLink && setConfirmShiftLink(payload.data.startAt);
      }
    } else if (payload.data.type == "document") {
      const amount = await getNotificationModelCount('document');
      await saveNotificationModelCount('document', amount);
    } else if (payload.data.type == "swapRequest") {
      const amount = await getNotificationModelCount('swapRequest');
      await saveNotificationModelCount('swapRequest', amount);
    } else if (payload.data.type == "leaveRequest") {
      const amount = await getNotificationModelCount('leaveRequest');
      // console.log('!amount', amount)
      await saveNotificationModelCount('leaveRequest', amount);
    }
    const shiftAmount = await getNotificationModelCount('shift');
    const shiftAcceptedAmount = await getNotificationModelCount('shiftAccepted');
    const openShiftAmount = await getNotificationModelCount('openShift');
    const openShiftAcceptedAmount = await getNotificationModelCount('openShiftAccepted');
    const confirmShiftAmount = await getNotificationModelCount('confirmShift');
    const documentAmount = await getNotificationModelCount('document');
    const swapRequestAmount = await getNotificationModelCount('swapRequest');
    const leaveRequestAmount = await getNotificationModelCount('leaveRequest');
    const postAmount = await getNotificationModelCount('post');
  
    const notifAmount = (shiftAmount + shiftAcceptedAmount + openShiftAmount + openShiftAcceptedAmount + 
      confirmShiftAmount + documentAmount + swapRequestAmount + leaveRequestAmount + postAmount); //leaveRequestAmount
    // console.log('notfi', notifAmount);
    await saveNotificationModelCount('notification', notifAmount);
  };

  useEffect(() => {
    if (!client || !client.type) return;
    clientRef.current = client;
    setTimeout(checkForLink, 1000);
    // if (!user.comId) return
    // subscribeToTopics(user.comId, user.userId);
  }, [client]);

  // CLIENT PROBLEM (console wierd fix ... useEffect needed)
  // if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  //   onMessage(messaging, (payload) => {
  //     if (payload) {
  //       console.log('allo!!!',payload.data);
  //       // const currentClient = clientRef.current;
  //       // setTimeout(() => {
  //         if (payload.data.senderId != client?.userId) {
  //         // if (payload.data.senderId != currentClient?.userId) {
  //           console.log('good',payload.data);
  //           buildNotifLocalStorage(payload);
  //           // console.log('payload', payload)
  //           refreshNotifyModels(payload);
  //         }
  //       // }, 1000);
  //     }
  //   });
  // }

  useEffect(() => {

    //if (isMacOSApp || isWindowApp) {

      if (window.webkit?.messageHandlers?.callbackHandler) {
        // Receive token from native side
        window.onTokenReceived = function(token) {
            console.log("FCM TOKEN RECEIVED");//, token);
        };

        // window.webkit.messageHandlers.callbackHandler.postMessage({ 
        //     action: "subscribeTopic", 
        //     fCMToken: FCMToken 
        // });

        subscribeToTopicsNative();

        // TELL SWIFT JS IS READY
        window.webkit.messageHandlers.callbackHandler.postMessage({ action: "jsReady" });
      }

      window.onNativeNotificationReceived = function(data) {
        // console.log("Notification reçue via le pont natif :", data);
        
        if (data.aps && data.aps.alert) {
          // const title = data.aps.alert.title;
          // const body = data.aps.alert.body;
          // alert("Notification reçue : " + title + " - " + body);
          
          if (clientRef?.current) {
            // Construct a MessagePayload-like object for buildNotifLocalStorage
            const payload = {
              data: data,
              from: data.from || "",
              collapseKey: data.collapseKey || "",
              messageId: data["gcm.message_id"] || Math.random().toString(36).substring(2, 15)

            };
            const currentClient = clientRef?.current;
            if (payload.data.senderId !== currentClient?.userId) {
              const path = window.location.pathname;
              switch (path) {
                case t('link.posts'):
                  if (payload.data.type == "post") return;
                  break;
                case `${t('link.posts')}/${payload.data.senderId}`:
                  const currentId = path.split('/posts/')[1];
                  // if (payload?.from === "/topics/"+clientRef.current?.comId+"_posts") {
                  if (payload.data.type == "post" && currentId == payload.data.senderId ) return;
                  break;
                case t('link.shifts'):
                  if (payload.data.type == "shift") return;
                  break;
                case t('link.open_shifts'):
                  if (payload.data.type == "open_shifts") return;
                  break;
                case "/documents":
                  if (payload.data.type == "document") return;
                  break;
                case t('link.requests_swap'):
                  if (payload.data.type == "requestSwap") return;
                  break;
                case t('link.requests_leave'):
                  if (payload.data.type == "requestLeave") return;
                  break;
                // default:
                //   buildNotifLocalStorage(payload);
                //   refreshNotifyModels(payload);
                //   break;
              }
              buildNotifLocalStorage(payload);
              refreshNotifyModels(payload);
            }
          }
        }
      };

      window.onNativeNotificationLinkReceived = function(data) {
        if (clientRef?.current) {
          clientRef.current = client;
          switch(data.type) {
            case "post":
              updateNotificationModelLink("postLink", "");
              if (data.senderId) {
                navigate(`${t('link.posts')}/${data.senderId}`, { replace: true, state: {} });
              } else {
                navigate(t('link.posts'), { replace: true, state: {} });
              }
              break;
            case "shift":
              updateNotificationModelLink("shiftLink", "");
              if (client?.type === "MANAGER") {
                navigate(t('link.shifts'), { replace: true, state: {} });
              } else {
                navigate(t('link.shifts'), { replace: true, state: {} });
              }
              break;
            case "openShift":
              getNotificationModelLink("openShiftLink");
              if (client?.type === "MANAGER") {
                navigate(`${t('link.scheduler')}${t('link.open_shifts')}`, { replace: true, state: {} });
              } else {
                navigate(t('link.open_shifts'), { replace: true, state: {} });
              }
              break;
            case "confirmShift":
              updateNotificationModelLink("confirmShiftLink", "");
              if (client?.type === "MANAGER") {
                navigate(t('link.scheduler'), { replace: true, state: {} });
              } else {
                navigate('/agenda', { replace: true, state: {} });
              }
              break;
            case "document":
              updateNotificationModelLink("documentLink", "");
              navigate('/documents', { replace: true, state: {} });
              break;
            case "swapRequest":
              updateNotificationModelLink("swapRequestLink", "");
              navigate(t('link.requests_swap'), { replace: true, state: {} });
              break;
            case "leaveRequest":
              updateNotificationModelLink("leaveRequestLink", "");
              navigate(t('link.requests_leave'), { replace: true, state: {} });
              break;
          }
        }
      };

      if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

      const unsubscribe = onMessage(messaging, (payload) => {

        if (!payload?.data) return;
        // console.log(payload);
        // console.log(payload.data);
        // console.log("notification:", payload.notification);

        const currentClient = clientRef.current;

        if (payload.data.senderId !== currentClient?.userId) {
          const path = window.location.pathname;
          switch (path) {
            case t('link.posts'):
              if (payload.data.type == "post") return;
              break;
            case `${t('link.posts')}/${payload.data.senderId}`:
              const currentId = path.split('/posts/')[1];
              // if (payload?.from === "/topics/"+clientRef.current?.comId+"_posts") {
              if (payload.data.type == "post" && currentId == payload.data.senderId ) return;
              break;
            case t('link.shifts'):
              if (payload.data.type == "shift") return;
              break;
            case t('link.open_shifts'):
              if (payload.data.type == "open_shifts") return;
              break;
            case "/documents":
              if (payload.data.type == "document") return;
              break;
            case t('link.requests_swap'):
              if (payload.data.type == "requestSwap") return;
              break;
            case t('link.requests_leave'):
              if (payload.data.type == "requestLeave") return;
              break;
            // default:
            //   buildNotifLocalStorage(payload);
            //   refreshNotifyModels(payload);
            //   break;
          }
          buildNotifLocalStorage(payload);
          refreshNotifyModels(payload);
          if (isWindowApp) {
              notifyWindows(payload.notification.title, payload.notification.body);
          }
        }
      });

      return () => {
        // Important : nettoie le listener sinon chaque render en empile un nouveau
        if (typeof unsubscribe === 'function') unsubscribe();
      };
    // }
  }, []);

  useEffect(() => {
    const data = ['post', 'openShift', 'openShiftAccepted', 'shift', 'shiftAccepted', 'confirmShift', 'document', 'swapRequest', 'leaveRequest'];
    for(const model of data) {
      updateModelCount(model);
    }
  }, [location]);

  

  useEffect(() => {
    const savedLang = Cookies.get('language');
    if (savedLang) {
      i18n.changeLanguage(savedLang);
      if (!document.getElementById('schedulum-schema-ld')) {
        injectSEOHeadContent(t, savedLang);
      }
    } else {
      changeLanguage("en");
    }
  }, [i18n]);

  // const renderNavBar = (user?: AuthUser, client?: any) => {

  const onSignInPressed = async ({username, password}: SignInData) => {
    if (loading) {
      return;
    }
    setLoading(true);
    try {
      const { isSignedIn, nextStep } = await signIn({username, password});
      // console.log(nextStep);
      // if (nextStep.signInStep == 'CONFIRM_SIGN_UP') {
      //   navigate('/');
      // }
      navigate(t('link.dashboard'), { state: { status: "bg-dark", title: "", toastMessage: t('toast.welcome'), toastUsername: true }});
    } catch (error) {
        console.log('error signing in: ', error);
        alert('LogIn error: '+ (error as Error).message);
    } finally {
      setLoading(false);
      reset();
    };
  };

  const logOut = () => {
    signOut();
    localStorage.clear();
    navigate('/');
  }

  const goToRegister = () => {
    navigate(t('link.signup'));
  }
  
  // opacity-75
  // console.log('TYPE', client);

  // useEffect(() => {
  //   console.log('notificationCount', notificationCount);
  //   console.log('shiftCount', shiftCount);
  //   console.log('shiftAcceptedCount', shiftAcceptedCount);
  //   console.log('confirmShiftCount', confirmShiftCount);
  //   console.log('openShiftCount', openShiftCount);
  //   console.log('openShiftAcceptedCount', openShiftAcceptedCount);
  //   console.log('documentCount', documentCount);
  //   console.log('swapRequestCount', swapRequestCount);
  //   console.log('leaveRequestCount', leaveRequestCount);
  //   console.log('postCount', postCount);
  //   }, [notificationCount]);
  // }, [notificationCount, shiftCount, shiftAcceptedCount, confirmShiftCount, openShiftCount, openShiftAcceptedCount, documentCount, swapRequestCount, leaveRequestCount, postCount]);
  return (
    <Navbar expand="lg" data-bs-theme="dark" className="customNavbar bg-body-tertiary">
      <Container>
        <Navbar.Brand href="/">
          <img src="/logo/Schedulum.png" width="50" height="50"/>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {/* <Nav.Link href="/">Home</Nav.Link> */}
            <Nav.Link href={t('link.news')}>{t('navBar.news')}</Nav.Link>
            { user && client?.type === "MANAGER" &&
              <>
                <Nav.Link href={t('link.users')}>{t('navBar.users')}</Nav.Link>
              
                <NavDropdown title={t('navBar.tools')} id="basic-nav-dropdown" style={{position: "relative", width: "100%", top:0,left:0,zIndex:2000}}>
                  {/* <NavDropdown.Item href="/table">{t('navBar.table')}</NavDropdown.Item> */}
                  <NavDropdown.Item href={t('link.dashboard')}>{t('navBar.dashboard')}</NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown title={t('navBar.scheduler')} id="basic-nav-dropdown" className="dropend dropdown-item nested-dropdown" style={{position: "relative", width: "100%", top:0,left:0,zIndex:2000}}>
                    <div className="dropdown-arrow"></div>
                    <NavDropdown.Item href={t('link.scheduler')}>{t('navBar.scheduler')}</NavDropdown.Item>
                    <NavDropdown.Item href={`${t('link.scheduler')}${t('link.open_shifts')}`}>{t('home.manageOpenShift')}</NavDropdown.Item>
                  </NavDropdown>
                  <NavDropdown title={t('navBar.agenda')} id="basic-nav-dropdown" className="dropend dropdown-item nested-dropdown" style={{position: "relative", width: "100%", top:0,left:0,zIndex:2000}}>
                    <div className="dropdown-arrow"></div>
                    <NavDropdown.Item href="/agenda">{t('navBar.agenda')}</NavDropdown.Item>
                    <NavDropdown.Item href={`/agenda/${t('link.management')}`}>{t('navBar.agendaManager')}</NavDropdown.Item>
                  </NavDropdown>
                  
                  <NavDropdown.Divider />
                    <NavDropdown title={t('navBar.shifts')} id="basic-nav-dropdown" className="dropend dropdown-item nested-dropdown" style={{position: "relative", width: "100%", top:0,left:0,zIndex:2000}}>
                      <div className="dropdown-arrow"></div>
                      <NavDropdown.Item href={t('link.shifts')}>{t('navBar.shifts')}</NavDropdown.Item>
                      <NavDropdown.Divider />
                      <NavDropdown.Item href={t('link.table_shift')}>{t('navBar.table')}</NavDropdown.Item>
                      <NavDropdown.Item href={t('link.excel_shift')}>
                        {/* <Nav.Link href="/excel_import">{t('navBar.spreadsheet')}</Nav.Link> */}
                        {t('navBar.spreadsheet')}
                      </NavDropdown.Item>
                    </NavDropdown>
                    <NavDropdown title={t('navBar.open_shifts')} id="basic-nav-dropdown" className="dropend dropdown-item nested-dropdown" style={{position: "relative", width: "100%", top:0,left:0,zIndex:2000}}>
                      <div className="dropdown-arrow"></div>
                      <NavDropdown.Item href={t('link.open_shifts')}>{t('navBar.open_shifts')}</NavDropdown.Item>
                      <NavDropdown.Divider />
                      <NavDropdown.Item href={t('link.table_open_shift')}>
                        {t('navBar.table')}
                      </NavDropdown.Item>
                      <NavDropdown.Item href={t('link.excel_open_shift')}>
                        {/* <Nav.Link href="/excel_import">{t('navBar.spreadsheet')}</Nav.Link> */}
                        {t('navBar.spreadsheet')}
                      </NavDropdown.Item>
                    </NavDropdown>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href={t('link.posts')}> {t('navBar.posts')}</NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="/documents"> {t('navBar.documents')}</NavDropdown.Item>
                    <NavDropdown.Item href={`${t('link.worker')}/documents`}> {t('navBar.myDocuments')}</NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown title={t('navBar.request')} id="basic-nav-dropdown" className="dropend dropdown-item nested-dropdown" style={{position: "relative", width: "100%", top:0,left:0,zIndex:2000}}>                        
                        <div className="dropdown-arrow"></div>
                        <NavDropdown.Item href={t('link.swap_management')}>{t('request.managerTab')}</NavDropdown.Item>
                        <NavDropdown.Item href={t('link.suggested_requests_swap')}>{t('request.receiveTab')}</NavDropdown.Item>
                        <NavDropdown.Item href={t('link.requests_swap')}>{t('request.giveTab')}</NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item href={t('link.leave_management')}>{t('request.managerLeaveTab')}</NavDropdown.Item>
                        <NavDropdown.Item href={t('link.requests_leave')}>{t('request.leaveTab')}</NavDropdown.Item>
                        <NavDropdown.Item href={t('link.leave_create')}>{t('request.createLeaveTab')}</NavDropdown.Item>
                    </NavDropdown>
                  {/* <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item> */}
                  {/* <NavDropdown.Divider /> */}
                </NavDropdown>
              </>
            }
            { user && client?.type === "EMPLOYEE" &&
              <>
                <Nav.Link href={t('link.users')}>{t('navBar.users')}</Nav.Link>
                {/* <Nav.Link href="/table">Table</Nav.Link> */}
                {/* <Nav.Link href="/excel_import">{t('navBar.spreadsheet')}</Nav.Link> */}
              
                <NavDropdown title={t('navBar.tools')} id="basic-nav-dropdown" style={{position: "relative", width: "100%", top:0,left:0,zIndex:2000}}>
                  {/* <NavDropdown.Item href="/table">{t('navBar.table')}</NavDropdown.Item> */}
                  <NavDropdown.Item href={t('link.dashboard')}>{t('navBar.dashboard')}</NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item href="/agenda">{t('navBar.agenda')}</NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item href={t('link.shifts')}>{t('navBar.shifts')}</NavDropdown.Item>
                  <NavDropdown.Item href={t('link.open_shifts')}>{t('navBar.open_shifts')}</NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item href={t('link.posts')}> {t('navBar.posts')}</NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item href="/worker/documents"> {t('navBar.myDocuments')}</NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown title={t('navBar.request')} id="basic-nav-dropdown" className="dropend dropdown-item nested-dropdown" style={{position: "relative", width: "100%", top:0,left:0,zIndex:2000}}>                        
                      <div className="dropdown-arrow"></div>
                      <NavDropdown.Item href={t('link.requests_swap')}>{t('request.giveTab')}</NavDropdown.Item>
                      <NavDropdown.Divider />
                      <NavDropdown.Item href={t('link.requests_leave')}>{t('request.leaveTab')}</NavDropdown.Item>
                      <NavDropdown.Item href={t('link.leave_create')}>{t('request.createLeaveTab')}</NavDropdown.Item>
                  </NavDropdown>
                  {/* <NavDropdown.Divider /> */}
                  {/* <NavDropdown.Item href="/excel_import">
                    Spreadsheet
                  </NavDropdown.Item> */}
                  {/* <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item> */}
                  {/* <NavDropdown.Divider />
                  <NavDropdown.Item href="#action/3.4">
                    Separated link
                  </NavDropdown.Item> */}
                </NavDropdown>
              </>
            }
            <Nav.Link href={t('link.help')}>{t('navBar.help')}</Nav.Link>
            <NavDropdown title={t('navBar.language')} id="basic-nav" style={{position: "relative", width: "100%", top:0,left:0,zIndex:2000}}>
              <NavDropdown.Item href="#" onClick={() => changeLanguage('en')} className={'justify-content-end'}>En</NavDropdown.Item>
              <NavDropdown.Item href="#" onClick={() => changeLanguage('fr')} className={'justify-content-end'}>Fr</NavDropdown.Item>
            </NavDropdown>
          </Nav>
          { user ?
          <Nav>
            <Nav.Item className="notification_navbar_wrapper d-flex align-items-center me-lg-3">
              { notificationCount > 0 && 
                <a href="#" onClick={goToBestNotification}>
                  <Badge pill bg="danger" className="notification_navbar" >
                    {notificationCount}
                  </Badge>
                </a>
            //     <a href="#" onClick={goToBestNotification}>
            //     <span className="notification_navbar"> {notificationCount} </span>
            //  </a>
              }
              
              <FaRegBell size={30} color="#CCC"/>
            </Nav.Item>
            <NavDropdown title={
              <UserImage user={client} customClass="coworker_sm shadow-sm hover:shadow-md" key={"login_" + user.userId} />
            }
            className="justify-content-end" 
            align="end" 
            style={{position: "relative", width: "80px", top:0,left:0,zIndex:2000}}>
              <NavDropdown.Item href={t('link.dashboard')}>{t('navBar.dashboard')}</NavDropdown.Item>
              <NavDropdown.Item href={t('link.settings')}>{t('navBar.settings')}</NavDropdown.Item>
              <NavDropdown.Item href="#" onClick={logOut} className={'justify-content-end'}>{t('navBar.signout')}</NavDropdown.Item>
            </NavDropdown>
          </Nav>
            // LOGOUT LINK
            
            // <Nav className="justify-content-end" activeKey="/home">

            //   <Nav.Item>
            //     <Nav.Link href="#" onClick={logOut} className={'justify-content-end'}>{t('navBar.signout')}</Nav.Link>
            //   </Nav.Item>
            // </Nav>
            :
            // LOGIN FORM
            <>
              <Form className="d-flex d-inline align-items-right me-2 justify-content-end flex-wrap flex-sm-nowrap">
              {/* <Form className="d-flex align-items-end">  */}
                {/* <Row className="align-items-end">
                  <Col> */}
                    <InputGroup>
                      <InputGroup.Text id="basic-addon1">@</InputGroup.Text>
                      <Form.Control
                        placeholder={t('navBar.email')}
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        className="d-inline me-lg-2"
                        {...register("username")} 
                        name="username"
                      />
                    </InputGroup>
                  {/* </Col>
                  <Col> */}
                    <InputGroup>
                      <Form.Control
                        type="password"
                        placeholder={t('navBar.password')}
                        className="me-lg-2" 
                        {...register("password")} 
                        name="password"
                      />
                    </InputGroup>
                  {/* </Col>
                  <Col> */}
                    <InputGroup>
                      <Button type="submit" onClick={handleSubmit(onSignInPressed)}>{t('navBar.login')}</Button>
                      <Button type="button" onClick={goToRegister}>{t('navBar.signup')}</Button>
                    </InputGroup>
                  {/* </Col>
                </Row> */}
              </Form>
            </>
          }
        </Navbar.Collapse>
        
      </Container>
    </Navbar>
  )
}
  //refreshNotifyModels, 
  // return {
  //   renderNavBar
  // }
// }

export default RenderNavBar; //NavBarItems;